import * as React from "react";
import { ModelState } from "../../Models/ModelStateEnum";
import RbhRequestServiceableCreate from "./RbhRequestServiceableCreate";
import RbhRequestServiceableUpdate from "./RbhRequestServiceableUpdate";
import RbhRequestServiceableView from "./RbhRequestServiceableView";
import { ServiceableStatu } from "../../../../Enums/ServiceableStatus";

const RbhRequestServiceable = props => {
  const [tabType, setTabType] = React.useState(ModelState.Create);
  React.useEffect(() => {
    var tempTabType =
      props?.requestServiceableData === null
        ? ModelState.Create
        : [ServiceableStatu.Accepted, ServiceableStatu.Rejected].includes(props?.requestServiceableData?.status)
          ? ModelState.View
          : ModelState.Edit;
    setTabType(tempTabType);
  }, [props?.requestServiceableData]);
  switch (tabType) {
    case ModelState.Create:
      return (
        <RbhRequestServiceableCreate
          resource="/requestserviceables"
          basePath=""
          requestId={props?.requestId}
          requestDetail={props?.requestDetailData}
          finalCallBack={e => props.parentCallBack()}
        />
      );
    case ModelState.Edit:
      return (
        <RbhRequestServiceableUpdate
          experienceData={props?.requestDetailData?.experience}
          serviceable={props?.requestServiceableData}
          finalCallBack={e => props.parentCallBack()}
          requestId={props.requestId}
        />
      );
    default:
      return (
        <RbhRequestServiceableView
          experienceData={props?.requestDetailData?.experience}
          serviceable={props?.requestServiceableData}
          requestDetail={props?.requestDetailData}
        />
      );
  }
};

export default RbhRequestServiceable;
